import DateHelper from "../Utility/DateHelper";

export const MAX_COINS: number = 9999999;
export const MAX_LIVES: number = 999;
export const MAX_BOOSTER_TNT: number = 999;
export const MAX_BOOSTER_BULLSEYE: number = 999;
export const MAX_BOOSTER_SHUFFLE: number = 999;
export const MAX_BOOSTER_UNDO: number = 999;
export const MAX_BOOSTER_JOKER: number = 999;
export const MAX_EXTRA_CARDS: number = 999;
export const MAX_BOOSTER_PLUSFIVE: number = 999;
export const HELPER_FRIENDS_COOLDOWN: number = DateHelper.hoursToMilliseconds(24);
